import { defineMessages } from "react-intl";
export default defineMessages({
    agroMeteorology: {
        id: "reports.agroMeteorology",
        defaultMessage: "Agrometeorology",
    },
    analysis: {
        id: "reports.analysis",
        defaultMessage: "Analysis",
    },
    annualCumulativeRainfallComparison: {
        id: "reports.annualCumulativeRainfallComparison",
        defaultMessage: "Annual Cumulative Rainfall Comparison",
    },
    cumulativeRainfall: {
        id: "reports.cumulativeRainfall",
        defaultMessage: "Cumulative rainfall",
    },
    cumulativeRainfallDescription: {
        id: "reports.cumulativeRainfallDescription",
        defaultMessage: "Track total rainfall accumulating over the selected period.",
    },
    annualHeatingDurationComparison: {
        id: "reports.annualHeatingDurationComparison",
        defaultMessage: "Annual heating duration comparison",
    },
    annualHeatingEfficiency: {
        id: "reports.annualHeatingEfficiency",
        defaultMessage: "Annual heating efficiency",
    },
    annualIndoorComparison: {
        id: "reports.annualIndoorComparison",
        defaultMessage: "Annual Indoor Comparison",
    },
    annualIndoorReport: {
        id: "reports.annualIndoorReport",
        defaultMessage: "Annual Indoor Report",
    },
    annualOutdoorComparison: {
        id: "reports.annualOutdoorComparison",
        defaultMessage: "Annual Outdoor Comparison",
    },
    annualOutdoorReport: {
        id: "reports.annualOutdoorReport",
        defaultMessage: "Annual Outdoor Report",
    },
    annualReport: {
        id: "reports.annualReport",
        defaultMessage: "Annual Report",
    },
    annualSolarReport: {
        id: "reports.annualSolarReport",
        defaultMessage: "Annual solar report",
    },
    annualWaterBalance: {
        id: "reports.annualWaterBalance",
        defaultMessage: "Annual water balance",
    },
    annualWaterBalanceDescription: {
        id: "reports.annualWaterBalanceDescription",
        defaultMessage: "The water balance (simplified version, only Rain and evapotranspiration are used) helps manage water supply",
    },
    annualWaterBalanceCarryOver: {
        id: "reports.annualWaterBalanceCarryOver",
        defaultMessage: "Carry over {year} ({value})",
    },
    avgHumidity: {
        id: "reports.avgHumidity",
        defaultMessage: "Average humidity",
    },
    avgMaxTemperature: {
        id: "reports.avgMaxTemperature",
        defaultMessage: "Average T°max",
    },
    avgMinTemperature: {
        id: "reports.avgMinTemperature",
        defaultMessage: "Average T°min",
    },
    avgPressure: {
        id: "reports.avgPressure",
        defaultMessage: "Average Pressure",
    },
    avgTemperature: {
        id: "reports.avgTemperature",
        defaultMessage: "Average temperature",
    },
    comfortable: {
        id: "reports.comfortable",
        defaultMessage: "Comfortable (45% {lessThan} Humidity ≤ 60%)",
    },
    dailyMaxRainfall: {
        id: "reports.dailyMaxRainfall",
        defaultMessage: "Daily Max. rainfall",
    },
    dataExport: {
        id: "reports.dataExport",
        defaultMessage: "Export data",
    },
    dataExportXlsxFormatDescription: {
        id: "reports.dataExportXlsxFormatDescription",
        defaultMessage: "Export all of your station's data in Excel format (*.xlsx). Once you click on the button, you will receive an email with the processed data after a few minutes.",
    },
    daysWithFrost: {
        id: "reports.daysWithFrost",
        defaultMessage: "Days with frost",
    },
    daysWithStrongFrost: {
        id: "reports.daysWithStrongFrost",
        defaultMessage: "Days with strong frost",
    },
    daysWithoutThaw: {
        id: "reports.daysWithoutThaw",
        defaultMessage: "Days without thaw",
    },
    emailSent: {
        id: "reports.emailSent",
        defaultMessage: "An email has been sent to your mailbox",
    },
    grasslandTemperatureSum: {
        id: "reports.grasslandTemperatureSum",
        defaultMessage: "Grassland temperature sum",
    },
    grasslandTemperatureSumDescription: {
        id: "reports.grasslandTemperatureSumDescription",
        defaultMessage: "If the sum of {threshold} is exceeded in spring, the sustainable start of vegetation has been reached (works in Europe)",
    },
    growingDegreeDays: {
        id: "reports.growingDegreeDays",
        defaultMessage: "Growing degree days",
    },
    highPressure: {
        id: "reports.highPressure",
        defaultMessage: "Anticyclone (Average Pressure ≥ 1013mbar)",
    },
    indoorReport: {
        id: "reports.indoorReport",
        defaultMessage: "Indoor Report",
    },
    keyFacts: {
        id: "reports.keyFacts",
        defaultMessage: "Key Facts",
    },
    longestRunOfRainyDays: {
        id: "reports.longestRunOfRainyDays",
        defaultMessage: "Longest run of rainy days",
    },
    longestRunWithoutRun: {
        id: "reports.longestRunWithoutRun",
        defaultMessage: "Longest run without rain",
    },
    lowPressure: {
        id: "reports.lowPressure",
        defaultMessage: "Low Pressure (Average Pressure {lessThan} 1013mbar)",
    },
    maxHumidity: {
        id: "reports.maxHumidity",
        defaultMessage: "Maximum humidity",
    },
    maxPressure: {
        id: "reports.maxPressure",
        defaultMessage: "Maximum Pressure",
    },
    maxPressureMagnitude24h: {
        id: "reports.maxPressureMagnitude24h",
        defaultMessage: "Maximum Magnitude (/24H)",
    },
    maxTempGreaterThan: {
        id: "reports.maxTempGreaterThan",
        defaultMessage: "T°max ≥",
    },
    maxTempMagnitude24h: {
        id: "reports.maxTempMagnitude24h",
        defaultMessage: "Maximum Magnitude (/24H)",
    },
    maxTemperature: {
        id: "reports.maxTemperature",
        defaultMessage: "Maximum temperature",
    },
    minHumidity: {
        id: "reports.minHumidity",
        defaultMessage: "Minimum humidity",
    },
    minPressure: {
        id: "reports.minPressure",
        defaultMessage: "Minimum Pressure",
    },
    minPressureMagnitude24h: {
        id: "reports.minPressureMagnitude24h",
        defaultMessage: "Minimum Magnitude (/24H)",
    },
    minTempMagnitude24h: {
        id: "reports.minTempMagnitude24h",
        defaultMessage: "Minimum Magnitude (/24H)",
    },
    minTemperature: {
        id: "reports.minTemperature",
        defaultMessage: "Minimum temperature",
    },
    monthlyHeatingEfficiency: {
        id: "reports.monthlyHeatingEfficiency",
        defaultMessage: "Monthly heating efficiency",
    },
    monthlyIndoorReport: {
        id: "reports.monthlyIndoorReport",
        defaultMessage: "Monthly Indoor Report",
    },
    monthlyOutdoorReport: {
        id: "reports.monthlyOutdoorReport",
        defaultMessage: "Monthly Outdoor Report",
    },
    monthlyReport: {
        id: "reports.monthlyReport",
        defaultMessage: "Monthly Report",
    },
    monthlySolarReport: {
        id: "reports.monthlySolarReport",
        defaultMessage: "Monthly solar report",
    },
    monthlyWindReport: {
        id: "reports.monthlyWindReport",
        defaultMessage: "Monthly Wind Report",
    },
    numberOfDays: {
        id: "reports.numberOfDays",
        defaultMessage: "Number of Days",
    },
    outdoorReport: {
        id: "reports.outdoorReport",
        defaultMessage: "Outdoor Report",
    },
    rainfall: {
        id: "reports.rainfall",
        defaultMessage: "Rainfall",
    },
    rainyDays: {
        id: "reports.rainyDays",
        defaultMessage: "Rainy days",
    },
    relativelyWet: {
        id: "reports.relativelyWet",
        defaultMessage: "Relatively wet (60% {lessThan} Humidity ≤ 80%)",
    },
    sendEmail: {
        id: "reports.sendEmail",
        defaultMessage: "Send email",
    },
    tooDry: {
        id: "reports.tooDry",
        defaultMessage: "Too dry (Humidity ≤ 45%)",
    },
    tooWet: {
        id: "reports.tooWet",
        defaultMessage: "Too wet (Humidity {greaterThan} 80%)",
    },
    tropicalNights: {
        id: "reports.tropicalNights",
        defaultMessage: "Tropical nights",
    },
    waterBalance: {
        id: "reports.waterBalance",
        defaultMessage: "Water balance",
    },
    yearToDateTemperature: {
        id: "reports.yearToDateTemperature",
        defaultMessage: "Year-to-date temperature",
    },
    yearToDateTemperatureComparison: {
        id: "reports.yearToDateTemperatureComparison",
        defaultMessage: "Year-to-date temperature comparison",
    },
});
